import type { FC } from 'react';

import Box from '@mui/material/Box';

import type { EntityComponentProps } from '../../types/EntityComponent.types';
import AssigneeInfo from './Detail/AssigneeInfo';

const AssigneeEntityContent: FC<EntityComponentProps> = ({ data }) => {
    return (
        <Box>
            <AssigneeInfo data={data} />
        </Box>
    );
};

export default AssigneeEntityContent;
